<template>
    <div class="d-flex flex-column gap-3">
        <!-- Local Preparer -->
        <v-card class="d-flex flex-column pa-4 usercard gap-3" data-testid="user-list-tab__local-preparer-card">
            <h5 class="font-size-md">{{ $nova.labelsName('my_reporting_units_page', 'commentary_local_preparer_label', 'Local Preparer') }}</h5>
            <div class="d-flex flex-wrap gap-3" data-testid="user-list-tab__local-preparer-list">
                <template v-if="(detail.submitter_detail || []).length > 0">
                    <v-chip
                        v-for="(user, index) in detail.submitter_detail"
                        :key="index"
                        :color="(userId === user._id) ? 'primary' : ''"
                        :class="['email-chip', { 'email-chip-bg': userId !== user._id }]"
                        text
                        data-testid="user-list-tab__local-preparer-chip"
                    >
                        <v-avatar left class="mr-2">
                            <v-icon>mdi-account-outline</v-icon>
                        </v-avatar>
                        <div class="name-email">
                            <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                            <span v-if="user.name && user.name.trim() && user.email"> - </span>
                            <span class="textLowercase">{{ user.email }}</span>
                        </div>
                    </v-chip>
                </template>
                <template v-else>
                    <div class="grey--text" data-testid="user-list-tab__local-preparer-empty">No Users assigned</div>
                </template>
            </div>
        </v-card>

        <!-- Local Approver -->
        <v-card class="d-flex flex-column pa-4 usercard gap-3" data-testid="user-list-tab__local-approver-card">
            <h5 class="font-size-md">{{ $nova.labelsName('my_reporting_units_page', 'commentary_local_approver_label', 'Local Approver') }}</h5>
            <div class="d-flex flex-wrap gap-3" data-testid="user-list-tab__local-approver-list">
                <template v-if="(detail.approver_detail || []).length > 0">
                    <v-chip
                        v-for="(user, index) in detail.approver_detail"
                        :key="index"
                        :color="(userId === user._id) ? 'primary' : ''"
                        :class="['email-chip', { 'email-chip-bg': userId !== user._id }]"
                        text
                        data-testid="user-list-tab__local-approver-chip"
                    >
                        <v-avatar left class="mr-2">
                            <v-icon>mdi-account-outline</v-icon>
                        </v-avatar>
                        <div class="name-email">
                            <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                            <span v-if="user.name && user.name.trim() && user.email"> - </span>
                            <span class="textLowercase">{{ user.email }}</span>
                        </div>
                    </v-chip>
                </template>
                <template v-else>
                    <div class="grey--text" data-testid="user-list-tab__local-approver-empty">No Users assigned</div>
                </template>
            </div>
        </v-card>

        <!-- Regional Approver -->
        <v-card class="d-flex flex-column pa-4 usercard gap-3" data-testid="user-list-tab__regional-approver-card">
            <h5 class="font-size-md">{{ $nova.labelsName('my_reporting_units_page', 'commentary_regional_approver_label', 'Regional Approver') }}</h5>
            <div class="d-flex flex-wrap gap-3" data-testid="user-list-tab__regional-approver-list">
                <template v-if="(detail.regional_approver_detail || []).length > 0">
                    <v-chip
                        v-for="(user, index) in detail.regional_approver_detail"
                        :key="index"
                        :color="(userId === user._id) ? 'primary' : ''"
                        :class="['email-chip', { 'email-chip-bg': userId !== user._id }]"
                        text
                        data-testid="user-list-tab__regional-approver-chip"
                    >
                        <v-avatar left class="mr-2">
                            <v-icon>mdi-account-outline</v-icon>
                        </v-avatar>
                        <div class="name-email">
                            <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                            <span v-if="user.name && user.name.trim() && user.email"> - </span>
                            <span class="textLowercase">{{ user.email }}</span>
                        </div>
                    </v-chip>
                </template>
                <template v-else>
                    <div class="grey--text" data-testid="user-list-tab__regional-approver-empty">No Users assigned</div>
                </template>
            </div>
        </v-card>

        <!-- Manager -->
        <v-card class="d-flex flex-column pa-4 usercard gap-3" data-testid="user-list-tab__manager-card">
            <h5 class="font-size-md">Manager</h5>
            <div class="d-flex flex-wrap gap-2" data-testid="user-list-tab__manager-list">
                <template v-if="(detail.manager_detail || []).length > 0">
                    <v-chip
                        v-for="(user, index) in detail.manager_detail"
                        :key="index"
                        :color="(userId === user._id) ? 'primary' : ''"
                        :class="['email-chip', { 'email-chip-bg': userId !== user._id }]"
                        text
                        data-testid="user-list-tab__manager-chip"
                    >
                        <v-avatar left class="mr-2">
                            <v-icon>mdi-account-outline</v-icon>
                        </v-avatar>
                        <div class="name-email">
                            <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                            <span v-if="user.name && user.name.trim() && user.email"> - </span>
                            <span class="textLowercase">{{ user.email }}</span>
                        </div>
                    </v-chip>
                </template>
                <template v-else>
                    <div class="grey--text" data-testid="user-list-tab__manager-empty">No Users assigned</div>
                </template>
            </div>
        </v-card>

        <!-- Admin Preparer -->
        <v-card class="d-flex flex-column pa-4 usercard gap-3" data-testid="user-list-tab__admin-preparer-card">
            <h5 class="font-size-md">Admin Preparer</h5>
            <div class="d-flex flex-wrap gap-2" data-testid="user-list-tab__admin-preparer-list">
                <template v-if="(detail.admin_preparer_detail || []).length > 0">
                    <v-chip
                        v-for="(user, index) in detail.admin_preparer_detail"
                        :key="index"
                        :color="(userId === user._id) ? 'primary' : ''"
                        :class="['email-chip', { 'email-chip-bg': userId !== user._id }]"
                        text
                        data-testid="user-list-tab__admin-preparer-chip"
                    >
                        <v-avatar left class="mr-2">
                            <v-icon>mdi-account-outline</v-icon>
                        </v-avatar>
                        <div class="name-email">
                            <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                            <span v-if="user.name && user.name.trim() && user.email"> - </span>
                            <span class="textLowercase">{{ user.email }}</span>
                        </div>
                    </v-chip>
                </template>
                <template v-else>
                    <div class="grey--text" data-testid="user-list-tab__admin-preparer-empty">No Users assigned</div>
                </template>
            </div>
        </v-card>

        <!-- Admin Approver -->
        <v-card class="d-flex flex-column pa-4 usercard gap-3" data-testid="user-list-tab__admin-approver-card">
            <h5 class="font-size-md">Admin Approver</h5>
            <div class="d-flex flex-wrap gap-2" data-testid="user-list-tab__admin-approver-list">
                <template v-if="(detail.admin_approver_detail || []).length > 0">
                    <v-chip
                        v-for="(user, index) in detail.admin_approver_detail"
                        :key="index"
                        :color="(userId === user._id) ? 'primary' : ''"
                        :class="['email-chip', { 'email-chip-bg': userId !== user._id }]"
                        text
                        data-testid="user-list-tab__admin-approver-chip"
                    >
                        <v-avatar left class="mr-2">
                            <v-icon>mdi-account-outline</v-icon>
                        </v-avatar>
                        <div class="name-email">
                            <span v-if="user.name && user.name.trim()">{{ user.name }}</span>
                            <span v-if="user.name && user.name.trim() && user.email"> - </span>
                            <span class="textLowercase">{{ user.email }}</span>
                        </div>
                    </v-chip>
                </template>
                <template v-else>
                    <div class="grey--text" data-testid="user-list-tab__admin-approver-empty">No Users assigned</div>
                </template>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'UserListTab',
    props: {
        detail: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        userId() {
            return this.$store.state.user?.id;
        }
    }
};
</script>

<style scoped>
</style>
